import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ucFirst',
    standalone: false,
})
export class UcFirstPipe implements PipeTransform {
    transform(value: string): string {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}
